<template>
    <CodiceFeanorView tool-module="railFence" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
